module.exports = __webpack_public_path__ + "static/404-5ca787a3e8f3dcf9102736946d22414d.png";